import i18next from 'i18next';
import React from 'react';
import theme from '@theme';

import {
  Dropdown,
  DropdownRowMultipleLines,
  INPUT_WIDTH,
} from '@commons/utils/styledLibraryComponents';
import Text, { CUSTOM_STYLE_FOR_DROPDOWN_TEXT, ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  BackgroundImage,
  DropdownItemContainer,
  ForegroundImage,
  ImageContainer,
  SubtitleContainer,
} from '@commons/PaginatedSupplierProductsDropdown/styledComponents';

import { CompositionDropdownContainer } from '../../styledComponents';

const DEFAULT_RECIPE_PICTURE = '/images/inpulse/recipe-photo-placeholder.svg';
const MAPPED_SP_PICTURE = '/images/inpulse/link-white-supplier-product.svg';

const RecipeDropdown = (props) => {
  const {
    handleEntityChange,
    recipes,
    isReadOnly,
    composition,
    isLoading,
    errorMessage = null,
    warningMessage = null,
    width = '340px',
  } = props;

  const renderedRecipes = recipes.map((recipe) => {
    const isAlreadyMapped = !!recipe.product;

    return {
      ...recipe,
      value: recipe.name,
      renderValue: () => (
        <DropdownItemContainer style={{ marginRight: '56px' }}>
          <ImageContainer>
            <BackgroundImage
              hasForegroundImage={!!isAlreadyMapped}
              src={recipe.img || DEFAULT_RECIPE_PICTURE}
            />
            {isAlreadyMapped && <ForegroundImage src={MAPPED_SP_PICTURE} />}
          </ImageContainer>
          <DropdownRowMultipleLines>
            <Text
              color={isAlreadyMapped && theme.colors.greys.light}
              font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
              style={{ ...CUSTOM_STYLE_FOR_DROPDOWN_TEXT, width: 'auto' }}
            >
              {recipe.name}
            </Text>
            <SubtitleContainer>
              <Text
                color={isAlreadyMapped ? theme.colors.greys.light : theme.colors.greys.dark}
                font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}
                style={{ ...CUSTOM_STYLE_FOR_DROPDOWN_TEXT, width: 'auto' }}
              >
                {recipe.category}
              </Text>
            </SubtitleContainer>
          </DropdownRowMultipleLines>
        </DropdownItemContainer>
      ),
    };
  });

  return (
    <CompositionDropdownContainer>
      <Dropdown
        customStyle={{ height: 'auto', width }}
        isDisabled={isReadOnly || isLoading}
        isErrorState={!!errorMessage}
        items={renderedRecipes}
        label={i18next.t('GENERAL.RECIPE')}
        labelStyle={{ font: theme.fonts.textSmall }}
        placeholder={i18next.t('GENERAL.SEARCH')}
        selectedItem={composition}
        tooltipText={i18next.t('ADMIN.PRODUCTS.COMPOSITION_TOOLTIP_RECIPE')}
        isRequired
        largeDropdownList
        onSelectionChange={handleEntityChange}
      />
      {errorMessage && (
        <Text
          color={ENUM_COLORS.INFO_RED}
          font={ENUM_FONTS.TEXT_SMALL_HEIGHT_14_WEIGHT_600}
          style={{ width: INPUT_WIDTH.LARGE }}
        >
          {errorMessage}
        </Text>
      )}
      {warningMessage && (
        <Text
          color={ENUM_COLORS.INFO_ORANGE}
          font={ENUM_FONTS.TEXT_SMALL_HEIGHT_14_WEIGHT_600}
          style={{ width: INPUT_WIDTH.LARGE }}
        >
          {warningMessage}
        </Text>
      )}
    </CompositionDropdownContainer>
  );
};

export default RecipeDropdown;
